module.exports = __webpack_public_path__ + "static/loading-3868a2ec430a9b376059c741e97c2242.png";